<script setup lang="ts">
import SiteHeader from '@components/layout/site-header';
import SiteFooter from '@components/layout/site-footer';

const { isMrbilit } = useWhiteLabel();
const route = useRoute();
</script>

<template>
    <div>
        <SiteHeader overlay-header desktop-color="blue" menu-color="blue" />
        <slot />
        <SiteFooter :is-home-page="route.path === '/'" />
        <VitePwaManifest v-if="isMrbilit" />
    </div>
</template>
